import { takeLatest, put } from 'redux-saga/effects';

import * as managePendingRequest from '../requests/manage-pending-request';
import * as pendingAssignments from '../../dependentManagement/assignment-pending-req';
import * as pendingReviewed from '../../dependentManagement/assignment-reviewed-req';

function* handleManagePendingRequest() {
  yield put(pendingAssignments.actions.send({ offset: 0, limit: 10 }));
  yield put(pendingReviewed.actions.send({ offset: 0, limit: 10 }));
}

export default function* handleAcceptedConsentSaga() {
  yield takeLatest(
    managePendingRequest.actions.succeed,
    handleManagePendingRequest,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/manage-pending.js